<template>
  <div class="container-denied">
    <div>Доступ к странице запрещен</div>
    <md-button class="md-primary" @click="back">Назад</md-button>
  </div>
</template>

<script>
  export default {
    name: "AccessDenied",
    methods: {
      back() {
        this.$router.push(`./`);
      }
    }
  }
</script>

<style scoped>
  .container-denied {
    height: 100vh;
    width: 100vw;
    display:flex;
    flex-direction: column;
    background-color: #EEEEEE;
    align-items: center;
    justify-content: center;
  }
</style>